export const DATE_DAYJS_FORMAT = {
	US: 'YYYY-MM-DD',
	FR_SHORT: 'DD/MM/YYYY',
	FR_LONG: 'dddd, D MMMM YYYY',
	FR_SEMI_LONG: 'ddd D MMM YYYY',
	FR_LONG_WITH_HOUR: 'dddd, D MMMM YYYY à HH:mm'
};
